import type {
	ReviewNode,
	ReviewPhoto,
	ReviewsForGallery,
} from '@api/graphql/reviews/getReviewsForGallery';
import type { Review } from 'types/api/reviews';
import type { Gallery } from 'types/reviews';

export type ReviewWithGallery = Pick<
	Review,
	'gallery' | 'id' | 'rating' | 'createdDate' | 'content'
> & { reviewer: Pick<Review['reviewer'], 'firstName' | 'lastName'> };
export type ReviewsForGalleryResponse = {
	data: ReviewWithGallery[];
	reviewsSummary: {
		gallery: {
			photoCount: number;
		};
	};
};

export const mapReviewsForGallery = (
	data: ReviewsForGallery,
): ReviewsForGalleryResponse => {
	return {
		data: mapReviews(data.reviews.nodes),
		reviewsSummary: {
			gallery: {
				photoCount: data.summaryReviews.gallery.photoCount,
			},
		},
	};
};

const mapReviews = (reviews: ReviewNode[]): ReviewWithGallery[] => {
	return reviews.map((review) => {
		return mapReview(review);
	});
};

const mapReview = (review: ReviewNode): ReviewWithGallery => {
	return {
		id: review.id,
		rating: review.overallRating || 0,
		createdDate: review.createdAt,
		content: review.content,
		reviewer: {
			firstName: review.reviewer?.firstName || '',
			lastName: review.reviewer?.lastName || '',
		},
		gallery: mapPhotos(review.photos),
	};
};

const mapPhotos = (photos: ReviewPhoto[]): Gallery[] => {
	if (!photos) {
		return [];
	}

	return photos.filter((photo) => photo.active).map(mapPhoto);
};

const mapPhoto = (photo: ReviewPhoto): Gallery => {
	return {
		typeCode: 'PHOTO',
		active: photo.active === undefined ? true : photo.active,
		source: {
			application: 'theknot', // This is not implemented in the new API but needed for our types
		},
		sourceId: photo.sourceId || '',
		timestamp: {
			createdAt: photo.createdAt,
			updatedAt: photo.updatedAt,
		},
		name: photo.name || '',
		width: photo.width || 0,
		height: photo.height || 0,
	};
};
